import { render, staticRenderFns } from "./SolicitacaoAcesso.vue?vue&type=template&id=6c0011bb&"
import script from "./SolicitacaoAcesso.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports